import { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import CustomInputField from "../../../../../components/CustomHTMLElements/CustomInputField";
import CustomSearchDropDown from "../../../../../components/CustomHTMLElements/CustomSearchDropDown/CustomSearchableDropdown";
import { schemaWithOutPassword, schemaWithPassword } from "./helper";

const CreateUserComponent = ({
  setErrorMessage,
  onCloseModal,
  dataRecord,
  modifiedRolesData,
  validationResponse,
  scrollToTop,
  validatedEmail,
}) => {
  const [selectedRoles, setSelectedRoles] = useState([]);

  const { action } = dataRecord;

  const { register, handleSubmit, errors, setError, setValue } = useForm({
    resolver: yupResolver(
      validationResponse && !validationResponse?.existsOnlyOnSso
        ? schemaWithPassword
        : schemaWithOutPassword
    ),
  });

  useEffect(() => {
    setValue("email", validatedEmail);
  }, []);

  const handleDropdownChange = (data) => {
    setSelectedRoles(data);
  };

  const manageUser = (data) => {
    const payload = { ...data };

    payload.roleIds = selectedRoles.map((item) => item?.id);

    if (selectedRoles.length < 1) {
      scrollToTop();

      setErrorMessage("You have not selected any role");
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
    }
    if (validationResponse && !validationResponse?.existsOnlyOnSso) {
      payload.existsOnlyOnSso = false;
      if (data.password !== data.confirmPassword) {
        setError("confirmPassword", {
          type: "required",
          message: "Passwords do not match",
        });
        setError("password", {
          type: "required",
          message: "Passwords do not match",
        });
        return;
      }
    } else {
      payload.existsOnlyOnSso = validationResponse?.existsOnlyOnSso;
    }

    onCloseModal();
    setTimeout(() => {
      delete data.confirmPassword;
      action(payload);
    }, 100);
  };

  return (
    <>
      <small className="error-element text-center">
        Please enter new user information below.
      </small>
      <form autoComplete="off" onSubmit={handleSubmit(manageUser)}>
        <div className="m-t-2 m-b-2">
          <CustomInputField
            type="email"
            maxLength="50"
            reference={register}
            name="email"
            placeholder="Email"
            label="Email"
            errors={errors.email}
            iconType="fas fa-envelope"
          />
        </div>
        <div className="m-t-2 m-b-2">
          <CustomInputField
            type="text"
            maxLength="50"
            reference={register}
            name="firstName"
            placeholder="First Name"
            label="First Name"
            errors={errors.firstName}
            iconType="fas fa-user"
          />
        </div>
        <div className="m-t-2 m-b-2">
          <CustomInputField
            type="text"
            maxLength="50"
            reference={register}
            name="lastName"
            placeholder="Last Name"
            label="Last Name"
            errors={errors.lastName}
            iconType="fas fa-user"
          />
        </div>
        <div className="m-t-2 m-b-2">
          <CustomInputField
            type="number"
            maxLength="20"
            reference={register}
            name="phone"
            placeholder="Phone Number"
            label="Phone Number"
            errors={errors.phone}
            iconType="fas fa-phone"
          />
        </div>
        <div className="m-t-2 m-b-2">
          <CustomSearchDropDown
            label="Select Role"
            onChange={handleDropdownChange}
            defaultOptions={modifiedRolesData}
            iconType={null}
            name="roleId"
            register={register}
            isShowLabel={true}
            isMulti={true}
          />
        </div>
        <>
          {!validationResponse?.existsOnlyOnSso && (
            <>
              <div className="m-t-2 m-b-2">
                <CustomInputField
                  type="password"
                  maxLength="128"
                  reference={register}
                  name="password"
                  placeholder="Password"
                  label="Password"
                  errors={errors.password}
                  iconType="fas fa-lock"
                />
              </div>
              <div className="m-t-2 m-b-2">
                <CustomInputField
                  type="password"
                  maxLength="128"
                  reference={register}
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  label="Confirm Password"
                  errors={errors.confirmPassword}
                  iconType="fas fa-lock"
                />
              </div>
            </>
          )}
        </>

        <div className="Form__action-buttons m-t-1">
          <button
            type="button"
            className="btn zoom-element btn login-btn m-0 mr-auto"
            onClick={onCloseModal}
          >
            <i className="fas fa-times-circle"></i>
            &nbsp; Cancel
          </button>
          <button
            type="submit"
            className="btn zoom-element btn login-btn m-0 ml-auto"
            data-dismiss="modal"
          >
            <i className="fas fa-plus"></i>
            &nbsp; Create User
          </button>
        </div>
      </form>
    </>
  );
};

export default CreateUserComponent;
